var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"items":_vm.versions,"label":_vm.label,"chips":"","deletable-chips":""},on:{"input":_vm.selectVersion},model:{value:(_vm.localVersions),callback:function ($$v) {_vm.localVersions=$$v},expression:"localVersions"}})}
var staticRenderFns = []

export { render, staticRenderFns }